import { IProjectInstallationTimeline } from '@api/models';
import { getProjectInstallationTimeline } from '@api/services/project-installation.service';
import useAuthPermission from '@hooks/use-auth-permission';
import useDataQuery from '@hooks/use-data-query';
import { Card, CircularProgress } from '@hyperflake/react-ui-library';
import { TRootState } from '@store/index';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const ProjectInstallationTimeline = () => {
    const { clientInstallationId, projectInstallationId } = useParams();
    const { info: user } = useSelector((state: TRootState) => state.profile);

    const projectInstallationQuery = useDataQuery(
        ['project-timeline', clientInstallationId, projectInstallationId],
        () => getProjectInstallationTimeline(clientInstallationId, projectInstallationId),
        {
            enabled: Boolean(clientInstallationId && projectInstallationId),
        }
    );

    if (projectInstallationQuery.isLoading) {
        return (
            <Card className="mt-4">
                <Card.Header>Timeline</Card.Header>
                <Card.Body className="flex justify-center items-center">
                    <CircularProgress size={30} />
                </Card.Body>
            </Card>
        );
    }

    if (projectInstallationQuery.isError) {
        toast.error('Failed to fetch timeline data');
        return null;
    }

    const timelineData: IProjectInstallationTimeline[] = projectInstallationQuery.data;

    return (
        <Card className="mt-4">
            <Card.Header>Timeline</Card.Header>
            <Card.Body>
                <div className="space-y-4">
                    {timelineData && timelineData.length > 0 ? (
                        timelineData.map((timelineItem, index) => (
                            <div key={index} className="flex items-start space-x-4">
                                <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-white mt-1">
                                    {index + 1}
                                </div>
                                <div>
                                    <div className="text-lg font-semibold">
                                        {timelineItem.details ? (
                                            <>
                                                <div className="mb-1">
                                                    <span className="font-medium">Status:</span>{' '}
                                                    {timelineItem.projectTimeLineStatus.replace(/_/g, ' ')}
                                                </div>
                                                <div className="">
                                                    <div className="space-y-1 text-sm text-gray-500 border-2 m-2 p-2">
                                                        {Object.entries(timelineItem.details).map(
                                                            ([key, value]: [string, any]) => (
                                                                <div key={key} className="mt-2">
                                                                    <span className="font-medium capitalize text-gray-700 ">
                                                                        {key}:
                                                                    </span>
                                                                    <div className="flex items-center gap-2 px-2 ">
                                                                        <span className="  ">
                                                                            from: {value?.from ?? 'N/A'}
                                                                        </span>
                                                                        <span className="text-gray-400">:</span>
                                                                        <span className=" ">
                                                                            to: {value?.to ?? 'N/A'}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            )
                                                        )}
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            timelineItem.message
                                        )}
                                    </div>
                                    <div className="text-sm text-gray-500">
                                        {/* {new Date(timelineItem.createdAt).toLocaleString()} */}

                                        {moment
                                            .tz(timelineItem.createdAt, user.timezone)
                                            .format('h:mm a [·] DD MMM, YYYY')}
                                    </div>
                                    <div className="text-sm text-gray-600">
                                        <span className="font-medium">By:</span> {timelineItem.createdBy.name}
                                    </div>
                                    {/* <div className="mt-1">
                                        <span className="font-medium">Status:</span>{' '}
                                        {timelineItem.projectTimeLineStatus}
                                    </div> */}
                                    {/* <div className="mt-2">
                                        <span className="font-medium">User:</span> {timelineItem.user}
                                    </div> */}
                                </div>
                            </div>
                        ))
                    ) : (
                        <p>No timeline data available.</p>
                    )}
                </div>
            </Card.Body>
        </Card>
    );
};

export default ProjectInstallationTimeline;
